import { AxiosResponse } from 'axios';

import { VodResponse } from 'store/railsBuilder/reducer.types';

function isVodEditorialsResponse(
    response: any,
): response is AxiosResponse<VodResponse> {
    return !!response?.data?.editorials;
}

export default isVodEditorialsResponse;
